import { render, staticRenderFns } from "./HoursOfOperation.vue?vue&type=template&id=55ac61c8&scoped=true&"
import script from "./HoursOfOperation.vue?vue&type=script&lang=ts&"
export * from "./HoursOfOperation.vue?vue&type=script&lang=ts&"
import style0 from "./HoursOfOperation.vue?vue&type=style&index=0&id=55ac61c8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ac61c8",
  null
  
)

export default component.exports